/// Shared "big cumulative number" formatter. Originally lived inline in
/// `TowerLogPage.tsx`; extracted so the static landing page's vanilla-JS
/// Tower Log strip (`src/landing/landingCore.ts`) can format the same way
/// without pulling in React.
///
/// Hero tiles hold at most 7 digits before they burst their card (the
/// passengers estimate proved it live). At a million and beyond, compact
/// notation fits AND reads more like the boast it is: "~2.5M".
export function formatCounterValue(value: number): string {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toLocaleString('en-US', { maximumFractionDigits: 1 })}M`
  }
  return Math.round(value).toLocaleString('en-US')
}
